import { gql } from '@apollo/client'

export const PAUSE_OPTIMIZATIONS = gql`
  mutation PauseOptimizations($input: PauseOptimizationsInput!) {
    pauseOptimizationsInCompanyStores(input: $input) {
      success
      storeIds
      optimizingPausedAt
      resumeOptimizingAt
    }
  }
`
